/**
 * 金额格式化与工资口径的单一定义。
 *
 * 两套存取口径（历史事实，函数名显式区分，禁止再在页面里手抄 formatAmount）：
 *   - 账务域（工/料/费/收/借支）后端以「分」存储；
 *   - 报价域（quotations/quotation_items）后端以「元」存储。
 * 曾因 12 个页面各抄一份、口径分裂（分/元混淆）出过首页万格式化 bug。
 */

// 分 → 人民币货币格式（账务域列表/详情通用）
// 2026-08-28 E2E 实测修复：原实现漏了 ÷100，导致利润/工资/材料等全部
// 页面金额放大 100 倍（收款 2 万显示成 ¥2,000,000）。后端账务域一律以分存储。
export function formatFen(fen = 0) {
  return ((Number(fen) || 0) / 100).toLocaleString('zh-CN', {
    style: 'currency', currency: 'CNY', minimumFractionDigits: 2, maximumFractionDigits: 2,
  });
}

// 元 → 人民币货币格式（报价域专用）
export function formatYuan(yuan = 0) {
  return (Number(yuan) || 0).toLocaleString('zh-CN', { style: 'currency', currency: 'CNY' });
}

// 首页统计卡片专用：分 → 大额缩写为「x.x万」，小额取整元
export function formatFenWan(fen = 0) {
  const n = Number(fen) || 0;
  if (Math.abs(n) >= 1000000) {
    // 分 → 元 ÷100，元 → 万 ÷10000，合计 ÷1000000（1,000,000 分 = ¥10,000 = 1 万）
    return `¥${(n / 1000000).toFixed(1)}万`;
  }
  return `¥${(n / 100).toLocaleString('zh-CN', {
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  })}`;
}

// 有效加班时薪（口径与后端 server.js effectiveOvertimeWage 一致）：
// 记工时锁定的快照值优先，缺省回退工人当前档案值。
// 后端必须在 SQL 里带出 workerOvertimeHourlyWage 别名字段（列表/:id/报表端点均已带）。
export function effectiveOvertimeWage(log) {
  return Number(log?.overtimeHourlyWage) || Number(log?.workerOvertimeHourlyWage) || 0;
}
